import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import Calendar from "../components/media/Calendar"

export default function CalendarPage() {
  const { tenantId } = useParams();
  const navigate = useNavigate();

  return (
    <Calendar
      tenantId={tenantId}
      initialView="month"
      onEventClick={(ev) => {
        // Adjust this path if your EventDetail route differs
        navigate(`/t/${tenantId}/events/${ev.id}`);
      }}
    />
  );
}
